import React, {ReactNode} from 'react';
import {classNames} from "../../../services/string";
import {FormikContextType, useFormikContext} from "formik";

const gridClasses = [
    'sm:grid-cols-1',
    'sm:grid-cols-2',
    'sm:grid-cols-3',
    'sm:grid-cols-4',
    'sm:grid-cols-5',
    'sm:grid-cols-6',
    'sm:grid-cols-7',
    'sm:grid-cols-8',
    'sm:grid-cols-9',
    'sm:grid-cols-10',
    'sm:grid-cols-11',
    'sm:grid-cols-12',
]

// Component ----

export type FormSectionProps = {
    name?: string
    description?: string
    columns?: number
    isTop?: boolean
    children?: ReactNode | ((form: FormikContextType<any>) => any)
}

function FormSection({name, description, isTop, columns, children}: FormSectionProps) {
    const form = useFormikContext();
    const columnIndex = Math.max(Number(columns) - 1, 0)

    return (
        <div className={classNames(!isTop && 'pt-8')}>
            {!!name &&
                <div className="mb-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                        {name}
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                        {description}
                    </p>
                </div>
            }

            <div className={classNames('relative grid grid-cols-1 gap-y-8 gap-x-4', gridClasses[columnIndex])}>
                {typeof children === 'function'? children(form) : children}
            </div>
        </div>
    );
}

export default FormSection;